module.exports = __webpack_public_path__ + "static/media/minus-solid.19cc5e14.svg";